import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const ESGVerificationStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1600px;
  } */

  .table-wrapper {
    margin-top: 21px;
  }

  .table {
    .table-row {
      .supplier {
        flex: 0 0 15%;
      }

      .business-type {
        flex: 0 0 15%;
      }

      .email {
        flex: 0 0 15%;
      }

      .phone {
        flex: 0 0 13%;
      }

      .status {
        flex: 0 0 9%;
      }

      .actions {
        flex: 0 0 7%;
      }

      .last-update {
        flex: 0 0 15%;
      }

      &.header {
        .actions {
          padding: 0 14px;
          justify-content: center;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
